/**
 * Created by Mat on 11/18/2015.
 */
e.A.password = {
	init : function(){
		$( '#password' ).find( '.expand' ).click( function(){
			e.A.password._expand( $( this ) );
		});

		$( '#update_email_submit' ).click(function( ev ){
			ev.preventDefault();
			e.A.password._update_email();
		});

		$( '#sign-out-all-sessions' ).click( this._signout_all_sessions );

		$( '[data-js="edspire/account-settings/save-password"]' ).on( 'click', this._save_password );
	},

	_save_password : function(){
		EdSpireAjax.Request('EdSpireAccountSettings',  'updatePassword', $('#password-reset').serializeArray(), function(){
			EdspireGrunt.AccountSettings.Messages.display_message( 'password_reset' );
		});
	},


	_signout_all_sessions : function(){
		var $this = $( this );
		wp.ajax.post( 'destroy-sessions', {
			nonce: $( '#signout-nonce' ).val(),
			user_id: $( '#signout-user_id' ).val()
		}).done( function( response ) {
			$this.prop( 'disabled', true );
			$this.siblings( '.notice' ).remove();
			$this.before( '<div class="notice notice-success inline"><p>' + response.message + '</p></div>' );
		}).fail( function( response ) {
			$this.siblings( '.notice' ).remove();
			$this.before( '<div class="notice notice-error inline"><p>' + response.message + '</p></div>' );
		});
	},

	_update_email : function(){
		EdSpireAjax.Request('EdSpireAccountSettings',  'updateAccountInfo', $('#email-update-form').serializeArray(), function(){
			$('#content-right-js').prepend('<div id="message" style="display:block" class="updated"><p>Your email address has been updated.</p></div>');
			$("html, body").animate({ scrollTop: 0 }, "slow");
		});

	},


	_expand : function( el ){
		var $id = el.attr( 'rel' );
		if( el.hasClass( 'closed' ) ){
			el.removeClass( 'closed' );
			el.addClass( 'open' );
			el.text( 'close' );
			$( '#' + $id ).slideDown();

		} else {
			el.removeClass( 'open' );
			el.addClass( 'closed' );
			$( '#' + $id ).slideUp();
			el.text( 'expand' );
		}
	}
};